import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const tableRows = [
  { feature: 'Ultraconverged Altyapı', production: 'check', backup: 'check' },
  { feature: 'Sınırsız Sanal Veri Merkezi', production: 'check', backup: 'check' },
  { feature: 'Global Veri Tekilleştirme', production: 'check', backup: 'check' },
  { feature: 'Reçete Marketi', production: 'check', backup: 'check' },
  { feature: 'Destek', production: '7/24/365', backup: 'Production Lisansı Gerektirir' },
  { feature: 'Kümeler', production: 'infinity', backup: 'infinity' },
  { feature: 'Düğümler', production: 'infinity', backup: 'infinity' },
  { feature: 'Düğüm Başına Maks. RAM', production: 'infinity', backup: 'infinity' },
  { feature: 'Maks. Kullanılabilir Depolama', production: 'infinity', backup: 'infinity' },
  { feature: 'Global Uzak Yönetim', production: 'check', backup: 'Production Lisansı Gerektirir' },
  { feature: 'Merkezi Uzak Yönetim', production: 'check', backup: 'Production Lisansı Gerektirir' },
  { feature: 'GPU Desteği', production: 'check', backup: 'Production Lisansı Gerektirir' },
];

const deployOptions = [
  { icon: 'ri-server-line', title: 'Kendi Donanımınızı Getirin', desc: 'Mevcut sunucu donanımınız üzerinde VergeOS kurulumu yapın.' },
  { icon: 'ri-store-2-line', title: 'Partner\'dan Onaylı Cihaz Satın Alın', desc: 'VergeOS sertifikalı donanım çözümleri için iş ortaklarımızı keşfedin.' },
  { icon: 'ri-cloud-line', title: 'Hyper-Scaler veya Colocation\'da Bare Metal', desc: 'Büyük bulut sağlayıcılarının veya kolokasyon merkezlerinin bare metal sunucularında çalıştırın.' },
];

const versionsJsonLd = { '@context': 'https://schema.org', '@type': 'WebPage', name: 'VergeOS Sürümleri', url: `${SITE_URL}/versions`, description: 'VergeOS sürüm geçmişi ve yeni özellikler. En güncel platform yetenekleri ve iyileştirmeleri.' };

export default function VersionsPage() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <SEOHead title="Sürümler | VergeOS Platform Güncellemeleri" description="VergeOS sürüm geçmişi ve yeni özellikler. En güncel platform yetenekleri, iyileştirmeler ve release notes." keywords="VergeOS sürümler, release notes, yeni özellikler, platform güncellemeleri, versiyon" canonicalPath="/versions" jsonLd={versionsJsonLd} />
      <Navbar />

      {/* Hero */}
      <section
        className="relative py-20 bg-cover bg-center"
        style={{ backgroundImage: "url('https://www.verge.io/wp-content/uploads/bb-plugin/cache/vergeio-background-hero-landscape.jpeg')" }}
      >
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 text-center px-6">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">VergeOS Sürümleri</h1>
          <h2 className="text-xl text-white/90 font-medium">VergeIO'nun fiyatlandırması benzersiz biçimde sade, sürprizsiz ve uygun maliyetlidir.</h2>
        </div>
      </section>

      {/* Pricing table */}
      <section className="py-16 bg-white">
        <div className="max-w-[900px] mx-auto px-6">
          <p className="text-center text-gray-500 mb-8 text-sm">Tüm konfigürasyonlar düğüm başına basit fiyatlandırma içerir</p>
          <div className="rounded-xl overflow-hidden border border-gray-100">
            {/* Table header */}
            <div className="grid grid-cols-3 bg-[#1a1a2e] text-white text-sm font-semibold">
              <div className="px-6 py-4"></div>
              <div className="px-6 py-4 text-center">Production</div>
              <div className="px-6 py-4 text-center">Backup</div>
            </div>
            {tableRows.map((row, i) => (
              <div key={i} className={`grid grid-cols-3 border-t border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-[#fafafa]'}`}>
                <div className="px-6 py-3 text-sm text-gray-700">{row.feature}</div>
                <div className="px-6 py-3 text-center">
                  {row.production === 'check' ? (
                    <span className="w-5 h-5 flex items-center justify-center mx-auto">
                      <i className="ri-checkbox-circle-fill text-[#e8600a] text-xl"></i>
                    </span>
                  ) : row.production === 'infinity' ? (
                    <span className="text-gray-700 text-lg font-bold">∞</span>
                  ) : (
                    <span className="text-xs text-gray-600">{row.production}</span>
                  )}
                </div>
                <div className="px-6 py-3 text-center">
                  {row.backup === 'check' ? (
                    <span className="w-5 h-5 flex items-center justify-center mx-auto">
                      <i className="ri-checkbox-circle-fill text-[#e8600a] text-xl"></i>
                    </span>
                  ) : row.backup === 'infinity' ? (
                    <span className="text-gray-700 text-lg font-bold">∞</span>
                  ) : (
                    <span className="text-xs text-gray-500">{row.backup}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Run Anywhere */}
      <section className="py-14 bg-[#f7f8fa]">
        <div className="max-w-[1100px] mx-auto px-6">
          <h2 className="text-2xl font-bold text-[#1a1a2e] text-center mb-10">Her Yerde Çalışır</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {deployOptions.map((opt, i) => (
              <div key={i} className="bg-white rounded-xl p-6 text-center border border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 bg-orange-50 rounded-full">
                  <i className={`${opt.icon} text-[#e8600a] text-2xl`}></i>
                </div>
                <h4 className="font-bold text-[#1a1a2e] mb-2 text-sm">{opt.title}</h4>
                <p className="text-xs text-gray-500 leading-relaxed">{opt.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FooterSection />
    </div>
  );
}
